import './App.css';
import Home from './pages/Home'
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Link
} from "react-router-dom";
import SearchPage from './pages/SearchPage'


function App() {
  return (
    //BEM naming convention
    <div className="app">

      <Router>

        <Switch>
          <Route path="/search">
            <SearchPage />
          </Route>
          <Route path="/about">
            <h1>This is the About page</h1>
          </Route>
          <Route path="/">
            <Home />
          </Route>
        </Switch>
        

      </Router>
     

    </div>
  ); 
}

export default App;
